import { createRouter, createWebHistory } from 'vue-router'
import PayrollView from '@/views/PayrollView.vue'
import FileUpload from '@/components/payroll/FileUpload.vue'
import PayrollEdit from '@/components/payroll/PayrollEdit.vue'
import PayrollCalc from '@/components/payroll/PayrollCalc.vue'

const routes = [
  {
    path: '/payroll',
    name: 'Payroll',
    redirect: () => {
      return {path: 'payroll/upload'}
    },
    component: PayrollView,
    children: [{
        path: 'upload',
        component: FileUpload
      }, {
        path: 'edit',
        component: PayrollEdit
      }, {
        path: 'calc',
        component: PayrollCalc
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
